import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const Membership = lazy(() => import("@/pages/Membership"));
import { ProtectedRoute } from "@/components/auth/ProtectedRoute";
export const Route = createFileRoute("/membership")({
  component: () => (
    <ProtectedRoute>
      <Membership />
    </ProtectedRoute>
  ),
});
